/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Scenario_CInputs */

const en_pol_scenario_c = /** @type {(inputs: Pol_Scenario_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep cloud · your API key`)
};

const id_pol_scenario_c = /** @type {(inputs: Pol_Scenario_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud Bystep · kunci API kamu`)
};

/**
* | output |
* | --- |
* | "Bystep cloud · your API key" |
*
* @param {Pol_Scenario_CInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_scenario_c = /** @type {((inputs?: Pol_Scenario_CInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Scenario_CInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_scenario_c(inputs)
	return en_pol_scenario_c(inputs)
});